/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CurrencyEntity,
    CurrencyEntityFromJSON,
    CurrencyEntityFromJSONTyped,
    CurrencyEntityToJSON,
} from './CurrencyEntity';
import {
    PortfolioEntity,
    PortfolioEntityFromJSON,
    PortfolioEntityFromJSONTyped,
    PortfolioEntityToJSON,
} from './PortfolioEntity';
import {
    SymbolWithExchangeDto,
    SymbolWithExchangeDtoFromJSON,
    SymbolWithExchangeDtoFromJSONTyped,
    SymbolWithExchangeDtoToJSON,
} from './SymbolWithExchangeDto';
import {
    TradeTypeEnum,
    TradeTypeEnumFromJSON,
    TradeTypeEnumFromJSONTyped,
    TradeTypeEnumToJSON,
} from './TradeTypeEnum';

/**
 * 
 * @export
 * @interface TradeWithSymbolDto
 */
export interface TradeWithSymbolDto {
    /**
     * 
     * @type {TradeTypeEnum}
     * @memberof TradeWithSymbolDto
     */
    type: TradeTypeEnum | null;
    /**
     * 
     * @type {SymbolWithExchangeDto}
     * @memberof TradeWithSymbolDto
     */
    symbol: SymbolWithExchangeDto;
    /**
     * 
     * @type {string}
     * @memberof TradeWithSymbolDto
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof TradeWithSymbolDto
     */
    date: Date;
    /**
     * 
     * @type {number}
     * @memberof TradeWithSymbolDto
     */
    amount: number;
    /**
     * 
     * @type {number}
     * @memberof TradeWithSymbolDto
     */
    unitPrice: number;
    /**
     * 
     * @type {number}
     * @memberof TradeWithSymbolDto
     */
    fees: number;
    /**
     * 
     * @type {string}
     * @memberof TradeWithSymbolDto
     */
    note?: string | null;
    /**
     * 
     * @type {CurrencyEntity}
     * @memberof TradeWithSymbolDto
     */
    currency: CurrencyEntity;
    /**
     * 
     * @type {string}
     * @memberof TradeWithSymbolDto
     */
    referenceId?: string | null;
    /**
     * 
     * @type {PortfolioEntity}
     * @memberof TradeWithSymbolDto
     */
    portfolio: PortfolioEntity;
    /**
     * 
     * @type {boolean}
     * @memberof TradeWithSymbolDto
     */
    processed: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TradeWithSymbolDto
     */
    deleted: boolean;
    /**
     * 
     * @type {string}
     * @memberof TradeWithSymbolDto
     */
    brokerName?: string | null;
}

export function TradeWithSymbolDtoFromJSON(json: any): TradeWithSymbolDto {
    return TradeWithSymbolDtoFromJSONTyped(json, false);
}

export function TradeWithSymbolDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TradeWithSymbolDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': TradeTypeEnumFromJSON(json['type']),
        'symbol': SymbolWithExchangeDtoFromJSON(json['symbol']),
        'id': json['id'],
        'date': (new Date(json['date'])),
        'amount': json['amount'],
        'unitPrice': json['unitPrice'],
        'fees': json['fees'],
        'note': !exists(json, 'note') ? undefined : json['note'],
        'currency': CurrencyEntityFromJSON(json['currency']),
        'referenceId': !exists(json, 'referenceId') ? undefined : json['referenceId'],
        'portfolio': PortfolioEntityFromJSON(json['portfolio']),
        'processed': json['processed'],
        'deleted': json['deleted'],
        'brokerName': !exists(json, 'brokerName') ? undefined : json['brokerName'],
    };
}

export function TradeWithSymbolDtoToJSON(value?: TradeWithSymbolDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': TradeTypeEnumToJSON(value.type),
        'symbol': SymbolWithExchangeDtoToJSON(value.symbol),
        'id': value.id,
        'date': (value.date.toISOString()),
        'amount': value.amount,
        'unitPrice': value.unitPrice,
        'fees': value.fees,
        'note': value.note,
        'currency': CurrencyEntityToJSON(value.currency),
        'referenceId': value.referenceId,
        'portfolio': PortfolioEntityToJSON(value.portfolio),
        'processed': value.processed,
        'deleted': value.deleted,
        'brokerName': value.brokerName,
    };
}

